import { FC } from 'react';

import Link from 'next/link';
import { UserOutlined } from '@ant-design/icons';
import { Grid, Tooltip } from 'antd';

import STATIC_ROUTES from '@data/staticRoutes.json';

import {
  LogoutButtonWrapper,
  StyledLogoutButton,
  MenuItem,
  SubMenu,
  SubMenuItem,
} from './styled';
import UserMenuLink from './UserMenuLink';
import TotalMileAmount, { ITotalMileAmount } from './TotalMileAmount';

const { useBreakpoint } = Grid;

export interface ILogoutButton extends ITotalMileAmount {
  fullName: string;
  isOnlyShowSignOut?: boolean;
}

const LogoutButton: FC<ILogoutButton> = ({
  fullName,
  totalMileAmount,
  isOnlyShowSignOut = false,
}) => {
  const screen = useBreakpoint();

  return (
    <LogoutButtonWrapper>
      <MenuItem>
        {!screen.xl ? (
          <StyledLogoutButton>
            <Tooltip title={fullName} placement='bottom'>
              <UserOutlined />
            </Tooltip>
          </StyledLogoutButton>
        ) : (
          <StyledLogoutButton>
            <UserOutlined />
            {fullName}
          </StyledLogoutButton>
        )}
        <SubMenu className='nav__submenu'>
          {(isOnlyShowSignOut
            ? USER_MENU_ITEMS.slice(-1)
            : USER_MENU_ITEMS
          ).map((link, i) => (
            <SubMenuItem key={`${link.label}-${i}`} index={i}>
              <Link prefetch={false} href={link?.href || ''} passHref>
                <UserMenuLink label={link.label} href={link.href} />
              </Link>
            </SubMenuItem>
          ))}
        </SubMenu>
      </MenuItem>

      <TotalMileAmount totalMileAmount={totalMileAmount} />
    </LogoutButtonWrapper>
  );
};

export default LogoutButton;

export const USER_MENU_ITEMS = [
  {
    label: 'Kullanıcı Bilgilerim',
    href: STATIC_ROUTES.userInformation,
  },
  {
    label: 'Kayıtlı Yolcularım',
    href: STATIC_ROUTES.registeredPassengers,
  },
  {
    label: 'Fatura Bilgilerim',
    href: STATIC_ROUTES.billingInformation,
  },
  {
    label: 'Kart Bilgilerim',
    href: STATIC_ROUTES.cardInformation,
  },
  {
    label: 'Seyahatlerim',
    href: STATIC_ROUTES.travels,
  },
  {
    label: 'Çıkış Yap',
    href: '/logout',
  },
];
